module.exports = __webpack_public_path__ + "static/media/disease.f942763f.svg";